import { APICALL } from 'helper/api/api';
import { currencySign, SERVER_ERR, SOMETHING_ERR } from 'helper/Constant';
import BTNLoading from 'helper/my-com/BTNLoading';
import ConfirmDelete from 'helper/my-com/ConfirmDelete';
import { auth, defaultIMG, emptyIMG, imgBaseURL, toastifyError, toastifySuccess } from 'helper/Utility';
import React from 'react'
import { useState } from 'react';
import {
    Col,
    Row,
    Table,
} from "react-bootstrap";
import { Link } from 'react-router-dom';
import img1 from "../../../assets/img/products1.png";

const Offer = ({ dashboardDetails, navigate }) => {
    const authID = auth('user')?.id
    const [offerList, setOfferList] = useState(dashboardDetails?.offer)
    const [dltModal, setDltModal] = useState({
        open: false,
        counterModal: false,
        msg: "",
        loading: false,
        type: "",
    })

    const [params, setParams] = useState({
        id: "",
        status: "",
        sellerCounterAmount: "",
    })


    const handleAction = async (type, item) => {
        if (type === "rejected") {
            setDltModal({ ...dltModal, 'open': true, msg: "Are you sure you want to reject this offer ??" })
        } else if (type === "accepted") {
            setDltModal({ ...dltModal, 'open': true, msg: "Are you sure you want to approve this offer ??" })
        } else {
            setDltModal({ ...dltModal, 'counterModal': true, msg: "Let me explain", type: type })
        }
        setParams({ ...params, id: item?._id, status: type })
    }

    const handleSubmit = async () => {
        if (dltModal?.type === "countered") {
            if (!params?.sellerCounterAmount || params?.sellerCounterAmount.trim() === "") {
                toastifyError("Please enter a counter amount");
                return false;
            }
            if (isNaN(params?.sellerCounterAmount) || Number(params?.sellerCounterAmount) <= 0) {
                toastifyError("Please enter a valid counter amount (positive number)");
                return false;
            }
        }
        setDltModal({ ...dltModal, 'loading': true })
        try {
            const res = await APICALL('/user/respondToOffer', 'post', params)
            if (res?.status) {
                toastifySuccess(res?.message)
                setOfferList(res?.data)
                setDltModal({...dltModal, 'open' : false})
            } else {
                toastifyError(SOMETHING_ERR)
            }
        } catch (error) {
            toastifyError(error?.response?.data?.message || SERVER_ERR)
        } finally {
            setDltModal({ ...dltModal, 'loading': false, open: false })
        }
    }

    const handleBuyNow = (item) => {
        if (item) {
            const productDetails = { ...item.productId, price: item.requestedAmount };
            navigate("/order-view", { state: productDetails });
        } else {
            console.error("Item is missing or undefined:", item);
        }
    };

    // console.log("offerList",offerList)

    return (
        <>
            <div className=" selller_edit_sellpromain">
                <div className="nn_edit_proname">My Offer & Customer Offer</div>
                <div className="seller_edit_sellpro">
                    {
                        offerList?.length > 0 ?
                            <Row className="seller_edit_sellpro_inner">

                                <div className="nn_order_details-pay table-responsive p-0">
                                    <Table className="mb-0">
                                        <thead>
                                            <tr>
                                                <th>Product Title</th>
                                                <th>Price</th>
                                                <th>Offer Price</th>
                                                <th className="text-end">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {offerList?.map((item, idx) => (
                                                <>
                                                    <tr>
                                                        <td width="30%">
                                                            <div className="imgwithtitle">
                                                                <img src={item?.productId?.gallery?.length > 0 ? imgBaseURL() + item?.productId?.gallery[0] : defaultIMG} alt="" />{item?.productId?.title}
                                                            </div>
                                                        </td>
                                                        <td>{currencySign}{item?.productId?.price}</td>
                                                        <td>{currencySign}{item?.requestedAmount}</td>
                                                        <td>
                                                            <div className="d-flexbutton">
                                                                {authID === item?.sellerId?._id ?
                                                                    item?.status == "accepted" ?  <p className='text-success'>Accepted</p>:
                                                                    item?.status == "rejected" ?  <p className='text-danger'>Rejected</p>:
                                                                    <>
                                                                        {item?.status !== "accepted" && <button type='button' className='myplo_addressbtn1' onClick={() => handleAction("accepted", item)}>Approve</button>}

                                                                        {item?.status !== "rejected" && <button type='button' className='statuspending' onClick={() => handleAction("rejected", item)}>Reject</button>}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {
                                                                            item?.status == "pending" ?
                                                                                <div className="text-warning">Pending</div>
                                                                                :
                                                                                item?.status == "rejected" ? <div className="text-danger">Rejected</div>
                                                                                    :
                                                                                    <>
                                                                                        <div className="statusaprprove">Approved</div>
                                                                                        <button onClick={() => handleBuyNow(item)} type='button' className='myplo_addressbtn1'>Buy Now</button>
                                                                                    </>
                                                                        }
                                                                    </>
                                                                }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </>
                                            ))}

                                        </tbody>
                                    </Table>
                                </div>
                            </Row>
                            :
                            <div className="nn_empty_tab text-center">
                                <img src={emptyIMG} alt="Empty" />
                                 <p>
                                      <strong className="text-black">You Haven't been offerd.. yet.</strong><br/>when the party planners find you, your offers will show up here!
                                    </p>
                            </div>
                    }
                </div>
            </div>

            <ConfirmDelete dltModal={dltModal} setDltModal={setDltModal} callFun={handleSubmit} />
            <>
                {dltModal?.counterModal && (
                    <div className="modal  fade show delete_modal"
                        style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", inset: "0px", }}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content p-2">
                                <div className="modal-body">
                                    <h4>Enter counter amount</h4>
                                    <input type="text" value={params?.sellerCounterAmount} onChange={(e) => setParams({ ...params, sellerCounterAmount: e.target.value })} className='form-control' name='count_amount' maxLength={4} placeholder='Amount' />
                                    <div className="nn_discard_btn">
                                        {dltModal?.loading ? <BTNLoading className={'btn1'} />
                                            : <button className="btn1" onClick={() => handleSubmit()}>Submit</button>
                                        }
                                        <button className="btn2" onClick={() => setDltModal({ ...dltModal, 'counterModal': false })}> Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        </>
    )
}

export default Offer